<div
  class="eclipse-main-tab-header padding-top-es padding-bottom-16 sticky-element-after-black-header d-flex justify-content-between"
  *ngIf="tabTitle && permissionObj['Intake_Opportunity_Title_Visible']"
>
  <span>Opportunity details</span>
  <span *ngIf="latestSubmissionId">
    <dds-button
      class="custom-button"
      [theme]="proceedToDocumentSubmissionButtonOptions.theme ?? _EMPTY"
      [kind]="proceedToDocumentSubmissionButtonOptions.kind ?? _EMPTY"
      [size]="proceedToDocumentSubmissionButtonOptions.size ?? _EMPTY"
      [width]="proceedToDocumentSubmissionButtonOptions.width ?? _EMPTY"
      [icon]="proceedToDocumentSubmissionButtonOptions.icon ?? _EMPTY"
      [isIconLeft]="
        proceedToDocumentSubmissionButtonOptions.isIconLeft ?? false
      "
      [role]="proceedToDocumentSubmissionButtonOptions.role ?? _EMPTY"
      [isInverse]="proceedToDocumentSubmissionButtonOptions.isInverse ?? false"
      [isColorBg]="proceedToDocumentSubmissionButtonOptions.isColorBg ?? false"
      [isLoading]="proceedToDocumentSubmissionButtonOptions.isLoading ?? false"
      [ariaLabel]="proceedToDocumentSubmissionLabel"
      [customClass]="
        proceedToDocumentSubmissionButtonOptions.customClass ?? _EMPTY
      "
      [disabled]="checkOverallRequirement()"
      (clicked)="onProceedToDocumentSubmission()"
      ><span>{{ proceedToDocumentSubmissionLabel }}</span></dds-button
    >
  </span>
</div>

<div class="right-panel-container">
  <dds-accordion
    *ngIf="permissionObj['Intake_ServicesAndDelivery_Visible']"
    [disabled]="accordionOptions.disabled"
    [isMulti]="accordionOptions.isMulti"
    [isOpen]="false"
    [isInverse]="accordionOptions.isInverse"
    [customClass]="accordionOptions.customClass"
    [size]="accordionOptions.size"
  >
    <dds-accordion-item>
      <span class="text-label eclipse-section-header" header
        >Services & Delivery Model</span
      >
      <div content>
        <app-service-delivery
          [summary]="false"
          [opportunityNumber]="opportunityNumber"
        ></app-service-delivery>
      </div>
    </dds-accordion-item>
  </dds-accordion>
  <!-- Details Section -->
  <div class="client-info margin-top-s">
    <div class="section">
      <dds-accordion
        [disabled]="accordionOptions.disabled"
        [isMulti]="accordionOptions.isMulti"
        [isOpen]="true"
        [isInverse]="accordionOptions.isInverse"
        [customClass]="accordionOptions.customClass"
        [size]="accordionOptions.size"
      >
        <dds-accordion-item>
          <span header>
            <div class="section-header">
              <span class="text-label eclipse-section-header"> Details </span>
            </div>
          </span>
          <span class="section-container1" content>
            <p
              *ngIf="permissionObj['Intake_Opportunity_Description_Visible']"
              class="text-label sub-heading eclipse-content-grey details-sub-header"
            >
              Please review the following information received from Jupiter and
              make edits if the information shown on the screen is incorrect.
            </p>
            <div class="section-container1">
              <app-opportunity-details-section
                [configLabels]="configLabels"
                [id]="opportunityNumber"
                [submissionData]="submissionDetails"
                [permissionObj]="permissionObj"
                (lepValueChange)="onLepValueChange($event)"
              ></app-opportunity-details-section>
            </div>
          </span>
        </dds-accordion-item>
      </dds-accordion>
    </div>
    <!--Complexity section-->
    <dds-accordion
      *ngIf="permissionObj['Intake_Opportunity_Complexity_Visible']"
      [disabled]="accordionOptions.disabled"
      [isMulti]="accordionOptions.isMulti"
      [isOpen]="isComplexitysectionOpen"
      [isInverse]="accordionOptions.isInverse"
      [customClass]="accordionOptions.customClass"
      [size]="accordionOptions.size"
    >
      <dds-accordion-item>
        <span header>
          <div class="section-header">
            <span class="text-label eclipse-section-header heading-adjustment"
              >Opportunity Complexity
            </span>
          </div>
        </span>
        <span class="section-container1" content>
          <p
            *ngIf="
              permissionObj['Intake_Complexity_DescriptionGreyGuidance_Visible']
            "
            class="text-label sub-heading eclipse-content-grey heading-adjustment"
          >
            {{complexityLabel}}
          </p>
          <div class="section-container1">
            <app-complexity-questions
              [configLabels]="configLabels"
              [submissionData]="submissionDetails"
              [OpportunityID]="opportunityNumber"
              [permissionObj]="permissionObj"
            ></app-complexity-questions>
          </div>
        </span>
      </dds-accordion-item>
    </dds-accordion>

    <!--Complexity Cyber Questions-->
    <div *ngIf="shouldShowOfferingQuestions()">
      <dds-accordion
        [disabled]="accordionOptions.disabled"
        [isMulti]="accordionOptions.isMulti"
        [isOpen]="true"
        [isInverse]="accordionOptions.isInverse"
        [customClass]="accordionOptions.customClass"
        [size]="accordionOptions.size"
      >
        <dds-accordion-item>
          <span header>
            <div class="section-header">
              <span class="text-label eclipse-section-header heading-adjustment"
                >Offering/Service Questions</span
              >
            </div>
          </span>
          <span class="section-container1" content>
            <div class="section-container1">
              <app-complexity-cyber-questions
                [OpportunityID]="opportunityNumber"
                [submissionData]="submissionDetails"
                [permissionObj]="permissionObj"
              ></app-complexity-cyber-questions>
            </div>
          </span>
        </dds-accordion-item>
      </dds-accordion>
    </div>
    <app-linked-opportunities
      *ngIf="permissionObj['Intake_Opportunity_LinkedOpportunities_Visible']"
      [dataOpportunityId]="opportunityNumber"
    ></app-linked-opportunities>
  </div>
</div>
